import { render, staticRenderFns } from "./createhelplist.vue?vue&type=template&id=6e5b736a"
import script from "./createhelplist.vue?vue&type=script&lang=js"
export * from "./createhelplist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports